import HttpService from './http.service';

const getSessionData = async session => {
  let sessionData;
  await HttpService.getById('SessionData', session)
    .then(res => {
      sessionData = res.data;
    })
    .catch(error => console.log(error));

  return sessionData;
};

const postSessionData = async session => {
  let sessionData;
  await HttpService.postByObject('SessionData', session)
    .then(res => {
      sessionData = res.data;
    })
    .catch(error => console.log(error));

  return sessionData;
};

export { getSessionData, postSessionData };
